export const size = {
  small: "540px",
  medium: "990px",
};
